// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"993cad75","415":"7b75e871","510":"f37d84e8","956":"c2e31137"}[chunkId] + ".chunk.js";
};